import { IMdfStrategicInitiativeAllocation, TMdfAllocationEntityKey } from '../../../model/types'

export interface IAllocationBreakdownRow {
  value: string
  amountLc: number
  percent: number
}

/**
 * Aggregates the activity's allocation split by one of its entity columns.
 * Allocations sharing a value are merged — an activity split across two `Print`
 * categories yields a single `Print` row with the summed amount and share, which
 * matches the de-duplicated badge list the breakdown expands from. Rows with an
 * empty value for that column are dropped; the result is sorted by amount desc.
 */
export const getAllocationBreakdown = (
  allocations: IMdfStrategicInitiativeAllocation[],
  key: TMdfAllocationEntityKey
): IAllocationBreakdownRow[] => {
  const rows = new Map<string, IAllocationBreakdownRow>()

  allocations.forEach((allocation) => {
    const value = allocation[key]

    if (!value) {
      return
    }

    const row = rows.get(value) ?? { value, amountLc: 0, percent: 0 }

    rows.set(value, {
      value,
      amountLc: row.amountLc + allocation.categoryAllocationLc,
      percent: row.percent + allocation.categoryAllocationPercent,
    })
  })

  return Array.from(rows.values()).sort((left, right) => right.amountLc - left.amountLc)
}
